module.exports = __webpack_public_path__ + "img/history-eight.8f08137f.png";